import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setCurrentRoom } from 'redux/actions'
import { Helmet } from 'react-helmet'
import FooterBar from 'components/FooterBar'
import ManageRooms from './ManageRooms'
import { RoomsContainer } from './styles'
import CurrentRoom from './CurrentRoom'
import { useQuery } from '@apollo/client'
import { GET_BOOKING_DETAILS_BY_BOOKING_ID } from 'graphql/service'
import { debouncedErrorMessage } from 'utils/messageUtil'

const RoomChange = () => {
  
  const bookingId = useParams().bookingId
  const dispatch = useDispatch()

  const { data: bookingData, error } = useQuery(GET_BOOKING_DETAILS_BY_BOOKING_ID, {
    variables: { bookingId }
  });

  useEffect(() => {
    if (!bookingData?.bookingByID) return;

    const roomBooking = bookingData.bookingByID.roomBookings?.[0];
    if (!roomBooking) return;

    const currentRoom = {
      ...roomBooking.room,
      pricePerNight: roomBooking.pricePerNight,
      bookingId,
      groupId: bookingData.bookingByID.group?.groupId,
      startDate: bookingData.bookingByID.checkedInAt || bookingData.bookingByID.checkInDate,
      endDate: bookingData.bookingByID.checkedOutAt || bookingData.bookingByID.checkOutDate,
    };

    dispatch(setCurrentRoom(currentRoom));
  }, [bookingData, bookingId, dispatch]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  return (
    <>
      <Helmet>
        <title>Room Change - Rook Hotel PMS</title>
        <meta name="description" content="Room Change - Rook Hotel PMS" />
      </Helmet>
      <RoomsContainer>
        <CurrentRoom />
        <ManageRooms />
      </RoomsContainer>
      <FooterBar />
    </>
  );
};

export default RoomChange;
